export default function TicketDetail(mid, lineItem) {
  this.mid = mid
  this.qty = lineItem.quantity
  this.itemId = lineItem.itemId
  this.itemName = lineItem.name
  this.cash = lineItem.cashPrice
  this.cashTax = lineItem.isTaxable ? Math.floor(lineItem.cashPrice * (lineItem.taxRate / 100)) : 0
  this.cashTotal = this.cash + this.cashTax
  this.fee = Math.max(lineItem.price - lineItem.cashPrice, 0)
  this.feeTax = lineItem.isTaxable ? Math.floor(this.fee * (lineItem.taxRate / 100)) : 0
  this.credit = lineItem.price
  this.creditTax = this.cashTax + this.feeTax
  this.creditTotal = this.credit + this.creditTax
  this.taxRate = lineItem.taxRate
  this.isSent = false
  this.isVoided = false
  this.isDiscountable = lineItem.isDiscountable
  this.discountApplied = lineItem.discount
  this.isGiftCard = lineItem.isGiftCard
  // this.giftCardAmount = 0
  // this.giftCardID = ""
  this.promptPrice = lineItem.promptPrice
  this.useMods = false
  this.printToKitchen = false
  // this.mods = []
}